import { useController, useFormContext } from 'react-hook-form'
import {
  FormControlLabel,
  formControlLabelClasses,
  Switch as MuiSwitch,
  SxProps,
} from '@mui/material'

import { DefaultElementProps } from 'common/interfaces'
import { SizingContainer } from 'components/SizingContainer'

import { Switch as SwitchProps } from './interface'

const style: SxProps = {
  width: '100%',
  border: 'none',
  wordBreak: 'break-word',
  [`& .${formControlLabelClasses.label}`]: {
    paddingLeft: 0,
  },
}

export default function Switch({
  label,
  defaultChecked,
  size,
  name,
}: SwitchProps & DefaultElementProps): JSX.Element {
  const { control } = useFormContext()
  const { field } = useController({
    name,
    control,
    defaultValue: defaultChecked ?? false,
  })

  return (
    <SizingContainer className="switch-wrap" size={size}>
      <FormControlLabel
        control={
          <MuiSwitch
            {...field}
            checked={field.value}
            onChange={(e) => {
              field.onChange(e)
            }}
          />
        }
        label={label}
        labelPlacement="start"
        sx={style}
      />
    </SizingContainer>
  )
}
